import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Spinner } from '@fluentui/react-components'
import { useAuth } from '../context/AuthContext'
import { safeRedirect } from '../lib/safeRedirect'

export function AzureCallback() {
  const { login } = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const token = searchParams.get('token')
    if (token) {
      login(token)
      // Land back on the page the user originally requested (the backend
      // appended ?redirect=<path> from the OAuth state) — e.g. the standalone
      // /submit-demand — instead of always the app home. safeRedirect rejects
      // anything that isn't a same-origin in-app path (open-redirect guard).
      const dest = safeRedirect(searchParams.get('redirect'))
      // Hard redirect (not React Router) so the whole app re-mounts with the
      // new auth token in context.
      window.location.replace(dest)
    } else {
      navigate('/login', { replace: true })
    }
  }, [searchParams, login, navigate])

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Spinner size="large" label="Signing in..." />
    </div>
  )
}
